import { render, staticRenderFns } from "./studyCenterManage.vue?vue&type=template&id=305262e2"
import script from "./studyCenterManage.vue?vue&type=script&lang=js"
export * from "./studyCenterManage.vue?vue&type=script&lang=js"
import style0 from "./studyCenterManage.vue?vue&type=style&index=0&id=305262e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports